/**
 * PU ↔ dtrader iframe sync: cookie names + mirror localStorage keys.
 * Must stay identical to root `src/constants/pu-sync-storage.ts`.
 */

export const BOTBLITZ_DTRADER_SYNC_COOKIE_NAME = 'botblitz_dtrader_sync';
export const BOTBLITZ_SESSION_COOKIE_NAME = 'botblitz_session';

export const BOTBLITZ_SYNC_APP_ID_KEY = 'botblitz_sync_app_id';
export const BOTBLITZ_SYNC_OAUTH_CLIENT_ID_KEY = 'botblitz_sync_oauth_client_id';
export const BOTBLITZ_SYNC_OAUTH_DERIV_APP_ID_KEY = 'botblitz_sync_oauth_deriv_app_id';

export const BOTBLITZ_PERSISTED_OAUTH_CLIENT_ID_KEY = 'botblitz_persisted_oauth_client_id';
export const BOTBLITZ_PERSISTED_OAUTH_DERIV_APP_ID_KEY = 'botblitz_persisted_oauth_deriv_app_id';

export const BOTBLITZ_GHOST_REAL_FACADE_SESSION_KEY = 'botblitz_ghost_real_facade_loginid';

export const BOTBLITZ_AUTH_LOG_FULL_LS_KEY = 'botblitz_auth_log_full';

export const BOTBLITZ_SESSION_COOKIE_MAX_RAW_LEN = 3500;
